import ExportarCsv from '@/global/components/DataGrid/components/CustomGridToolBar/ExportarCsv'
import { GridMenuButton } from '@/global/components/DataGrid/components/CustomGridToolBar/MenuComponents'
import { useFilterLocaisCentroStore } from '@/global/components/Selects'
import { hasPermission } from '@/hooks/useBackendMenu'
import localeText from '@/locales/datagrid'
import { CalculoEspelho, espelhoPonto } from '@/service/api'
import { useStore } from '@/store'
import BaixarCalculoButton from '@/templates/ManutencaoDoPonto/CalculoPonto/BaixarCalculoButton'
import CalcularEmpresa from '@/templates/ManutencaoDoPonto/CalculoPonto/calcular'
import columns from '@/templates/ManutencaoDoPonto/CalculoPonto/columns'
import SelectCompetencia, {
    useCompetencia,
} from 'global/components/Selects/SelectCompetencia'
import ContentGuide from 'global/guides/ContentGuide'
import { UploadIcon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import OverlayApresentacao, {
    IPasso,
} from 'templates/Apresentacao/OverlayApresentacao'

const passos: IPasso[] = [
    {
        title: 'Calcule o ponto',
        description: `Voce pode calcular o ponto de todos os funcionários da empresa 
        de uma só vez clicando no botão "Calcular".`,
        getHighlightElement: () => document.getElementById('calcular-empresa')!,
    },
    {
        title: 'Exportação',
        description: `Exporte os PDFs dos funcionários em um único arquivo ou ZIP. Selecione os funcionários na tabela e clique em "Exportar".`,
        parentElements: [
            () =>
                document.getElementById('toolbar-calculo')?.firstElementChild
                    ?.firstElementChild as any,
        ],
        getHighlightElement: () =>
            document.getElementsByClassName('MuiList-root')[0] as any,
    },
]

export default function CalculoPonto() {
    const [competencia, setCompetencia] = useCompetencia()
    const empresaId = useStore(state => state.companyId)

    const { data = [], isLoading } = espelhoPonto.useFetch({
        queryParams: {
            competencia,
            empresaId,
        },
    })

    const useFilter = useFilterLocaisCentroStore()
    const rows = data.filter(useFilter)

    return (
        <ContentGuide>
            <OverlayApresentacao
                passos={passos}
                name="calculo"
                position={{ top: '25%' }}
            />
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={['Manutenção do ponto', 'Cálculo do ponto']}
                >
                    <ContentGuide.Filtros
                        SelectEmpresas
                        SelectCentroCusto
                        SelectLocais
                    >
                        <SelectCompetencia
                            value={competencia}
                            onChange={setCompetencia}
                        />
                    </ContentGuide.Filtros>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    key="grid-calculo"
                    columns={columns}
                    rows={rows}
                    loading={isLoading}
                    checkboxSelection
                    components={{
                        Toolbar: () => (
                            <>
                                <div id="toolbar-calculo">
                                    <GridMenuButton
                                        startIcon={<UploadIcon />}
                                        label={localeText.toolbarExport}
                                    >
                                        <ExportarCsv
                                            label="Exportar todos como CSV"
                                            fileName="exportacao-calculo-ponto"
                                            mi
                                        />
                                        <BaixarCalculoButton
                                            competencia={competencia}
                                            formato="pdf"
                                        />
                                        <BaixarCalculoButton
                                            competencia={competencia}
                                            formato="zip"
                                        />
                                    </GridMenuButton>
                                </div>
                                {hasPermission(
                                    ['create', 'CálculoDoPonto'],
                                    () => (
                                        <CalcularEmpresa
                                            competencia={competencia}
                                        />
                                    ),
                                )}
                            </>
                        ),
                    }}
                    ToolbarProps={{ hideExportButton: true }}
                />
                <Outlet key="outlet-calculo" context={{ data }} />
            </ContentGuide.Card>
        </ContentGuide>
    )
}

export function useCalculoOutletContext() {
    return useOutletContext<{
        data: CalculoEspelho[]
    }>()
}
